// extracted by mini-css-extract-plugin
export default {"status_container":"AxAuthServiceConfiguration_status_container__FmdUl","status":"AxAuthServiceConfiguration_status__fISBG"};